import React from 'react'
import Avatar from 'material-ui/Avatar'
import { List, ListItem } from 'material-ui/List'
import Forward from 'material-ui/svg-icons/content/forward'
import IconButton from 'material-ui/IconButton'
import Clear from 'material-ui/svg-icons/content/clear'
import Check from 'material-ui/svg-icons/navigation/check'
import config from '../../config/config'
import ReactTooltip from 'react-tooltip'
import { checkJapanese, displayRole } from '../../lib/lib'

const ParticipantListDetails = ({name, uid, status, role, handleListClick, purpose, raise_staging, decline_show, user_role, user_id, location, direct}) => (
  <div className='flex justify-between'>
    <div className='flex justify-between items-center'>
      {false && <div
        className='br-100'
        style={{
          width: 16,
          height: 16,
          backgroundColor: (status === 'online') ? '#2CB72B' : '#9B9B9B'
        }}/>}
      <div className='pl3' style={{fontSize: 14, color: '#6B7C93'}}>{name}</div>
    </div>
    {(purpose === 'participants' || purpose === 'seminarParticipants') ? (
      <div className='flex justify-between items-center'>
        <div style={{fontSize: 16, color: '#6B7C93'}}>{(displayRole(location, role))}</div>
        {(purpose === 'seminarParticipants') ? (
          <div style={{height: 48, width: 48}}/>
        ) : (user_role != 'student') ? (
          <IconButton
            className='pr3 pl3 pointer'
            onClick={(e) => handleListClick(e, 'move', uid, name, user_id, role, direct)}
            iconStyle={{fill: '#AFB9C5'}}>
            <ReactTooltip
              place='top'
              multiline
              effect='solid'
              html/>
            <Forward data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `特定のテーブルへ移動` : `Move this participant`}
                </div>`}/>
          </IconButton>
        ) : (
          <div style={{height: 48, width: 48}}/>
        )
        }
      </div>
    ) : (purpose === 'questions') ? (
      <div className='flex justify-between items-center'>
        <div>
          {!raise_staging && <IconButton
            tooltip='Accept'
            onClick={(e) => handleListClick(e, 'accept', true, uid)}
            style={{backgroundColor: 'rgba(136, 224, 168, 0.18)', borderRadius: '100%'}}
            iconStyle={{fill: '#29B87A'}}>
            <Check/>
          </IconButton>}
        </div>
        <div className='ml3'>
          {(decline_show) ? (<IconButton
            tooltip='Decline'
            onClick={(e) => handleListClick(e, 'accept', false, uid)}
            style={{backgroundColor: 'rgba(240, 22, 49, 0.18)', borderRadius: '100%'}}
            iconStyle={{fill: '#F01631'}}>
            <Clear/>
          </IconButton>) : (<IconButton
              style={{borderRadius: '100%'}}>
            </IconButton>
          )}
        </div>
      </div>
    ) : ''}
  </div>
)

const Participants = ({participants, purpose, handleListClick, raise_staging, groupList, unassigned, user_role, location}) => (
  <div>
    <List style={{height: '84vh', overflow: 'auto'}}>
      {participants && (participants.map((val, index) => {
        let display = true
        if (purpose == 'participants') {
          let array = groupList.filter(user => user['uid'] === val.uid)
          let group = (typeof array[0] != 'undefined') ? (array[0]['group']) : (0)
          if (group != 0 && unassigned) {
            display = false
          }
        }
        if (display) {
          return (<ListItem
            key={index}
            disabled
            style={{borderBottom: '1px solid #d9d9d9', paddingTop: 5, paddingBottom: 9}}
            leftAvatar={(val.direct) ? (<Avatar src={'https://' + config.API_HOST + '/api/v1/image/' + val.name}/>) : (
              <Avatar style={{backgroundColor: 'rgb(188, 188, 188)'}}
                      src={'https://' + config.API_HOST + '/api/v1/image/' + val.user_id}/>)}>
            <ParticipantListDetails
              handleListClick={handleListClick}
              name={val.name}
              uid={val.uid}
              user_id={val.user_id}
              direct={val.direct}
              user_role={user_role}
              raise_staging={raise_staging}
              decline_show={(raise_staging) ? (val.raise) : (true)}
              role={val.role}
              purpose={purpose}
              status={'online'}
              location={location}
            />
          </ListItem>)
        }
      }))}
    </List>
  </div>
)

export default Participants



// WEBPACK FOOTER //
// ./src/components/SeminarTabs/Participants.js